<!------------ START TEMPLATE ------------>
<template>
  <div>
    <!------------ START FORM ------------>
    <form role="form" @submit.stop.prevent="onSubmit">
      <!-----============================ OBS: No status deve ter um campo SELECT que irá trazer as opções criadas pelo usuário na parte cadastro de Status do Menu USUARIO  ==================------->
      <div class="vx-row">
        <div class="vx-col mb-6">
          <span>CPA Percentual</span>
          <vs-switch
            color="success"
            v-model="formCadastro.cpaPercentual"
            style="width: 60px"
          >
            <span slot="on">Sim</span>
            <span slot="off">Não</span>
          </vs-switch>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>{{ formCadastro.cpaPercentual ? "CPA %" : "R$ CPA" }}</span>
          <money
            class="w-full vs-inputx vs-input--input large"
            name="CPA"
            id="CPA"
            v-model="formCadastro.cpa"
            v-validate="{ required: true }"
            :state="
              utilsList.validateState(this.veeFields, this.veeErrors, 'CPA')
            "
            :danger="
              !utilsList.validateState(this.veeFields, this.veeErrors, 'CPA')
            "
            v-bind="money"
          ></money>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>CPA Base</span>
          <money
            class="w-full vs-inputx vs-input--input large"
            name="CPA Base"
            id="CPA Base"
            v-model="formCadastro.cpaBase"
            v-validate="{ required: true }"
            :state="
              utilsList.validateState(
                this.veeFields,
                this.veeErrors,
                'CPA Base'
              )
            "
            :danger="
              !utilsList.validateState(
                this.veeFields,
                this.veeErrors,
                'CPA Base'
              )
            "
            v-bind="money"
          ></money>
        </div>
      </div>

      <hr class="mb-3" />

      <div class="vx-row">
        <div class="vx-col mb-6">
          <span>REV Percentual</span>
          <vs-switch
            color="success"
            v-model="formCadastro.revPercentual"
            style="width: 60px"
          >
            <span slot="on">Sim</span>
            <span slot="off">Não</span>
          </vs-switch>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>{{ formCadastro.revPercentual ? "REV %" : "R$ REV" }}</span>
          <money
            class="w-full vs-inputx vs-input--input large"
            name="REV"
            id="REV"
            v-model="formCadastro.rev"
            v-validate="{ required: true }"
            :state="
              utilsList.validateState(this.veeFields, this.veeErrors, 'REV')
            "
            :danger="
              !utilsList.validateState(this.veeFields, this.veeErrors, 'REV')
            "
            v-bind="money"
          ></money>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>REV Base</span>
          <money
            class="w-full vs-inputx vs-input--input large"
            name="REV Base"
            id="REV Base"
            v-model="formCadastro.revBase"
            v-validate="{ required: true }"
            :state="
              utilsList.validateState(
                this.veeFields,
                this.veeErrors,
                'REV Base'
              )
            "
            :danger="
              !utilsList.validateState(
                this.veeFields,
                this.veeErrors,
                'REV Base'
              )
            "
            v-bind="money"
          ></money>
        </div>
      </div>

      <vs-alert
        v-if="$validator.errors.all().length > 0"
        color="danger"
        title="Atenção!!"
        active="true"
        class="my-3"
        style="height: auto !important"
      >
        <ul>
          <li
            class="mb-2"
            v-for="error in $validator.errors.all()"
            :key="error.id"
          >
            {{ error }}
          </li>
        </ul>
      </vs-alert>
      <div class="vx-row">
        <div class="vx-col w-full text-right">
          <vs-button
            color="warning"
            type="border"
            class="mr-3 mb-2"
            @click.stop.prevent="onReset"
            >Cancelar</vs-button
          >
          <BotaoSubmit
            variant="success"
            :edit="this.dados == null ? false : true"
            :aguarde="aguardeCadastro"
          ></BotaoSubmit>
        </div>
      </div>
    </form>
    <!------------ END FORM ------------>
  </div>
</template>
<!------------ END TEMPLATE ------------>

<!------------ START SCRIPT ------------>
<script>
import locale from "../../../locale";
import Datepicker from "vuejs-datepicker";
import * as lang from "vuejs-datepicker/src/locale";
import vSelect from "vue-select";
import service from "../../../services";
import BotaoSubmit from "../../../components/BotaoSubmit";
import utilsList from "../../../utils/list";
import cpfCnpj from "../../../services/cpfCnpj";
import dataFunctions from "../../../utils/dateConversion";
import moment from "moment";
import { Money } from "v-money";
export default {
  props: {
    sideBar: {
      type: Boolean,
    },
    dados: {
      type: Object,
    },
    contadorRender: {
      type: Number,
    },
  },
  watch: {
    dados(value) {
      this.preencheForm();
    },
    contadorRender(value) {
      this.preencheForm();
    },
  },
  data() {
    return {
      utilsList,
      money: {
        decimal: ".",
        thousands: "",
        prefix: "",
        suffix: "",
        precision: 2,
      },
      decoded: utilsList.buscaToken(),
      aguardeCadastro: false,
      distribuidores: [],
      perfis: [],
      fornecedores: [],
      languages: lang,
      funcoesValicao: null,
      formCadastro: {
        idUsuario: null,
        status: true,
        nome: null,
        email: null,
        cpf: null,
        celular: null,
        telefone: null,
        dataNascimento: null,
        cep: null,
        endereco: null,
        numero: null,
        complemento: null,
        bairro: null,
        cidade: null,
        estado: null,
        pais: "BR",
        idDistribuidor: null,
        idPerfil: null,
        idFornecedor: null,
        login: null,
      },
    };
  },
  methods: {
    preencheForm() {
      console.log("preencheform");
      if (this.dados.hasOwnProperty('idUsuario')) {
        this.formCadastro.idUsuario = this.dados.idUsuario;
        this.formCadastro.status = this.dados.deletedAt == null ? true : false;
        this.formCadastro.nome = this.dados.nome;
        this.formCadastro.consultor = this.dados.consultor;
        this.formCadastro.email = this.dados.email;
        this.formCadastro.cpf = this.dados.cpf;
        this.formCadastro.celular = this.dados.celular;
        this.formCadastro.telefone = this.dados.telefone;
        this.formCadastro.dataNascimento = moment(this.dados.dataNascimento)
          .utc()
          .format("DD/MM/YYYY");
        this.formCadastro.cep = this.dados.cep;
        this.formCadastro.endereco = this.dados.endereco;
        this.formCadastro.numero = this.dados.numero;
        this.formCadastro.complemento = this.dados.complemento;
        this.formCadastro.bairro = this.dados.bairro;
        this.formCadastro.cidade = this.dados.cidade;
        this.formCadastro.estado = this.dados.estado;
        this.formCadastro.pais = this.dados.pais;
        this.formCadastro.login = this.dados.login;
        this.formCadastro.idDistribuidor = {
          id: this.dados.idDistribuidor,
          label: this.dados.distribuidor,
        };
        this.formCadastro.idPerfil = {
          id: this.dados.idPerfil,
          label: this.dados.perfil,
        };
        this.formCadastro.idFornecedor = {
          id: this.dados.idFornecedor,
          label: this.dados.fornecedor,
        };
      } else {
        this.resetForm();
      }
    },

    onSubmit() {
      var action = "AtualizarUsuarioAfiliado/" + this.formCadastro.idUsuario;
      var metodo = "put";
      var msgRetorno = "Dados Atualizados com sucesso";

      var objSend = { ...this.formCadastro };

      this.$validator.validateAll().then((result) => {
        if (result) {
          this.aguardeCadastro = true;
          service[metodo]("Usuario", action, objSend)
            .then((res) => {
              this.aguardeCadastro = false;
              this.$vs.notify({
                position: "top-center",
                title: "Atenção",
                text: `Operação Realizada com sucesso`,
                color: "success",
              });
              this.$emit("concluido");
            })
            .catch((error) => {
              this.aguardeCadastro = false;
              this.$vs.notify({
                position: "top-center",
                title: "Atenção",
                text: error,
                color: "danger",
              });
            });
        }
      });
    },

    keymonitor: function (event) {
      if (this.formCadastro.cep.length == 10) {
        this.$vs.loading();
        var cepbusca = this.formCadastro.cep.replace(".", "").replace("-", "");
        service
          .post("g", "BuscaCEP", {
            cep: cepbusca,
          })
          .then((res) => {
            this.formCadastro.endereco = res.data.street;
            this.formCadastro.bairro = res.data.neighborhood;
            this.formCadastro.cidade = res.data.city;
            this.formCadastro.estado = res.data.state;
            this.$vs.loading.close();
          })
          .catch((error) => {
            this.$vs.loading.close();
            this.$vs.notify({
              position: "top-center",
              title: "Atenção",
              text: "Não Foi possível encontrar o cep",
              color: "danger",
            });
          });
      }
    },
    buscaDadosSelects(model, array, campoDescricao, campoPK) {
      service.getAll("g", {}, `${model}/list`).then((res) => {
        res.data.forEach((element) => {
          if (element.deletedAt == null)
            this[array].push({
              id: element[campoPK],
              label: element[campoDescricao],
            });
        });
        console.log(this.regionais);
      });
    },
    resetForm() {
      this.formCadastro = {
        status: true,
        nome: null,
        email: null,
        cpf: null,
        celular: null,
        telefone: null,
        dataNascimento: null,
        cep: null,
        endereco: null,
        numero: null,
        complemento: null,
        bairro: null,
        cidade: null,
        estado: null,
        pais: "BR",
        idDistribuidor: null,
        idPerfil: null,
        idFornecedor: null,
        login: null,
      };
    },
    onReset(evt) {
      this.$emit("cancel");

      this.resetForm();
    },
  },
  created() {
    this.buscaDadosSelects("perfis", "perfis", "nomePerfil", "idPerfil");

    this.$validator.localize("ptBr", locale);
  },
  components: {
    Datepicker,
    BotaoSubmit,
    "v-select": vSelect,
    Money,
  },
};
</script>
<!------------ END SCRIPT ------------>
